import { FeatureFlagState } from './types';

export const initialState: FeatureFlagState = {
  channelFeatures: {},
  featureFlags: {},
  loading: true,
};
